import './Projeto.css';

const Projeto =  () =>  {

    return (
        <section className="projeto">
                <article className="projeto__principal">
                    <h3 className="projeto__titulo">Sobre a Nossa Jornada de Estudo e Autodescoberta</h3>
                    <p className="projeto__conteudo">Bem-vindo(a) ao espaço dedicado à expansão da consciência e ao aprofundamento nos ensinamentos de Jesus sob a lente transformadora da Doutrina Espírita.</p>
                    <p className="projeto__conteudo">Nosso projeto nasceu do desejo de trilhar um caminho de conhecimento e aprimoramento moral, buscando na Espiritualidade a chave para uma vida mais plena e significativa. Convidamos você a embarcar nesta jornada conosco!</p>                
                </article>

                <article className="projeto__principal">
                    <h3 className="projeto__titulo">O Cerne de Nossos Estudos: Doutrina e Evangelho</h3>
                    <p className="projeto__conteudo">Nosso enfoque principal reside na Doutrina Espírita, codificada por Allan Kardec, que se apresenta como o Consolador Prometido. Ela nos oferece uma compreensão lógica e esclarecedora sobre a vida, a morte, a justiça divina e o futuro que nos aguarda.</p>
                    
                    <p className="projeto__conteudo"><strong>Fundamento em Jesus:</strong> Nossos estudos têm como alicerce primordial os ensinamentos morais de Jesus Cristo, o Guia e Modelo para a Humanidade.</p>
                    <p className='projeto__conteudo'><strong>Luz dos Espíritos Superiores:</strong> A Doutrina nos é revelada por Espíritos Superiores, cujas mensagens trazem luz e clareza sobre as grandes questões da vida e do universo.</p>

                </article>



            </section>
    )


}

export default Projeto;